import { getPrices } from 'utils/utils';

export const usePrice = ({ price }) => {
	return getPrices(price);
};
